import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=e0970dae&scoped=true&"
import script from "./MetricCard.vue?vue&type=script&lang=js&"
export * from "./MetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=e0970dae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0970dae",
  null
  
)

export default component.exports